import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import CategoriesHelper from '@iso/lib/api/categoriesHelper';
import { notification } from '@iso/components';
import actions from './actions';
import { redirectPage} from "@iso/lib/helpers/utility";
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* CategoriesReadRequest() {
    yield takeEvery(actions.CATEGORIES_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(CategoriesHelper.read,payload);
      console.log('---serachResult--', searchResult )
      if (searchResult.status) {
        yield put(
          actions.categoriesListSuccess(
          searchResult.exportresult,  
          searchResult.result,
          searchResult.status,
          searchResult.totalRecordCount,
          searchResult.labelfilter,
          searchResult.grpfilter,
           payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(actions.categoriesListSuccess(
          [],[],0,0,{},{}, 0)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* CategoriesFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.CATEGORIES_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(CategoriesHelper.findById,payload.listid);
      console.log('22222222222222222', searchResult )

      if (searchResult.status && searchResult.result && searchResult.result.length > 0) {
        yield put(
          actions.categoriesListById(
          searchResult.result,
          searchResult.message
          )
        );
      }else if (searchResult.result && searchResult.result.length === 0){
        redirectPage("/404")
        }
    } catch (error) {
    }
  });
}
/*****end*************/




/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(CategoriesReadRequest),
    fork(CategoriesFindByIdRequest),
  ]);
}
